export const APAC_CHECKOUT_NAME = "apac-checkout";

export enum ApacCheckoutComponent {
  CardDisplay = "CardDisplay",
  CheckoutPaymentForm = "CheckoutPaymentForm",
  ContactInformationForm = "ContactInformationForm",
  CreditCardPayment = "CreditCardPayment",
  ErrorModal = "ErrorModal",
  PassengerRow = "PassengerRow",
  PassengerSelection = "PassengerSelection",
  PaymentFormContent = "PaymentFormContent",
  PaymentInformation = "PaymentInformation",
  SelectPayment = "SelectPayment",
  TravellerDetails = "TravellerDetails",
}
